
var namespace = '';
export const ADD_ACTIVITIES                     = namespace + 'ADD_ACTIVITIES';
export const SET_ACTIVITIES_END                 = namespace + 'SET_ACTIVITIES_END';
export const CLEAR_ACTIVITIES                   = namespace + 'CLEAR_ACTIVITIES'; 
export const ADD_ACTIVITY                       = namespace + 'ADD_ACTIVITY';


namespace = 'announcements.';
export const ADD_ANNOUNCEMENTS                  = namespace + 'ADD_ANNOUNCEMENTS';
export const SET_ANNOUNCEMENTS_END              = namespace + 'SET_ANNOUNCEMENTS_END';
export const CLEAR_ANNOUNCEMENTS                = namespace + 'CLEAR_ANNOUNCEMENTS';


namespace = 'cards.';
export const SET_CARDS                          = namespace + 'SET_CARDS';
export const REPLACE_CARD                       = namespace + 'REPLACE_CARD';
export const ADD_CARD                           = namespace + 'ADD_CARD';
export const ADD_CARDS                          = namespace + 'ADD_CARDS';

namespace = 'carouselItems.';
export const SET_CAROUSEL_ITEMS                 = namespace + 'SET_CAROUSEL_ITEMS';

namespace = 'alertModals.';
export const ADD_ALERT                          = namespace + 'ADD_ALERT';
export const POP_ALERT                          = namespace + 'POP_ALERT';
export const CLEAR_ALERTS                       = namespace + 'CLEAR_ALERTS';


namespace = 'categories.';
export const SET_CATEGORIES                     = namespace + 'SET_CATEGORIES';
export const ADD_CATEGORY                       = namespace + 'ADD_CATEGORY';
export const ADD_CATEGORIES                     = namespace + 'ADD_CATEGORIES';


namespace = 'challenges.';
export const SET_CHALLENGES                     = namespace + 'SET_CHALLENGES';
export const SET_PINNED                         = namespace + 'SET_PINNED';
export const REPLACE_CHALLENGE                  = namespace + 'REPLACE_CHALLENGE';
export const ADD_CHALLENGE                      = namespace + 'ADD_CHALLENGE';
export const ADD_CHALLENGES                     = namespace + 'ADD_CHALLENGES';


namespace = '';
export const SET_COMPANY_WELCOME                = namespace + 'SET_COMPANY_WELCOME';


namespace = 'leaderboards.';
export const SET_LEADERBOARDS                   = namespace + 'SET_LEADERBOARDS';
export const SET_TEAM_CHALLENGE_LEADERBOARDS    = namespace + 'SET_TEAM_CHALLENGE_LEADERBOARDS';
export const SET_TEAM_CHALLENGE_INFO            = namespace + 'SET_TEAM_CHALLENGE_INFO';
export const ADD_LEADERBOARD                    = namespace + 'ADD_LEADERBOARD';
export const ADD_LEADERBOARD_RECORDS            = namespace + 'ADD_LEADERBOARD_RECORDS';
export const ADD_CHALLENGE_RECORDS              = namespace + 'ADD_CHALLENGE_RECORDS';
export const SET_LEADERBOARD_RECORDS_END        = namespace + 'SET_LEADERBOARD_RECORDS_END';
export const CLEAR_LEADERBOARD_RECORDS          = namespace + 'CLEAR_LEADERBOARD_RECORDS';


namespace = '';
export const SET_LOADING_SPINNER_ENABLE         = 'SET_LOADING_SPINNER_ENABLE';
export const SET_LOADING_OVERLAY_ENABLE         = 'SET_LOADING_OVERLAY_ENABLE';

namespace = 'navbar.';
export const INIT_NAVBAR_STATE                  = namespace + 'INIT_NAVBAR_STATE';
export const SET_NAVBAR_ENABLE                  = namespace + 'SET_NAVBAR_ENABLE';
export const SET_NAVBAR_BACK_BUTTON_ENABLE      = namespace + 'SET_NAVBAR_BACK_BUTTON_ENABLE';
export const SET_NAVBAR_DONE_BUTTON_ENABLE      = namespace + 'SET_NAVBAR_DONE_BUTTON_ENABLE';
export const SET_NAVBAR_CLOSE_BUTTON_ENABLE     = namespace + 'SET_NAVBAR_CLOSE_BUTTON_ENABLE';
export const SET_NAVBAR_MENU_ENABLE             = namespace + 'SET_NAVBAR_MENU_ENABLE';
export const SET_NAVBAR_REWARDS_ENABLE          = namespace + 'SET_NAVBAR_REWARDS_ENABLE';
export const SET_NAVBAR_LOGOUT_BUTTON_ENABLE    = namespace + 'SET_NAVBAR_LOGOUT_BUTTON_ENABLE';
export const SET_NAVBAR_TITLE                   = namespace + 'SET_NAVBAR_TITLE';


namespace = 'notifications.';
export const SET_NOTIFICATIONS                  = namespace + 'SET_NOTIFICATIONS';
export const ADD_NOTIFICATION                   = namespace + 'ADD_NOTIFICATION';
export const ADD_NOTIFICATIONS                  = namespace + 'ADD_NOTIFICATIONS';


namespace = 'objectiveCategories.';
export const ADD_OBJECTIVE_CATEGORY             = namespace + 'ADD_OBJECTIVE_CATEGORY';
export const ADD_OBJECTIVE_CATEGORIES           = namespace + 'ADD_OBJECTIVE_CATEGORIES';


namespace = 'objectives.';
export const SET_OBJECTIVES                     = namespace + 'SET_OBJECTIVES';
export const ADD_OBJECTIVE                      = namespace + 'ADD_OBJECTIVE';


namespace = '';
export const SET_USER_ONBOARDING_COMPLETE       = namespace + 'SET_USER_ONBOARDING_COMPLETE';
export const SET_USER_ONBOARDING_PATHINDEX      = namespace + 'SET_USER_ONBOARDING_PATHINDEX';


namespace = 'plugins.';
export const SET_PLUGINS                        = namespace + 'SET_PLUGINS';


namespace = 'rewards.';
export const SET_REWARDS                        = namespace + 'SET_REWARDS';


namespace = '';
export const SET_SIDEBAR_ENABLE                 = namespace + 'SET_SIDEBAR_ENABLE';
export const TOGGLE_SIDEBAR                     = namespace + 'TOGGLE_SIDEBAR';


namespace = '';
export const SET_USER_TOKEN                     = namespace + 'SET_USER_TOKEN';
export const SET_USER_LOGGED_IN                 = namespace + 'SET_USER_LOGGED_IN';
export const SET_USER_PUBLIC                    = namespace + 'SET_USER_PUBLIC';
export const SET_USER_NO_COMPANY                = namespace + 'SET_USER_NO_COMPANY';
export const SET_USER_PROFILE                   = namespace + 'SET_USER_PROFILE'; 
export const SET_USER_RANK                      = namespace + 'SET_USER_RANK';
export const SET_USER_HEALTH                    = namespace + 'SET_USER_HEALTH'; 
export const SET_USER_BADGE_NUMBERS             = namespace + 'SET_USER_BADGE_NUMBERS'; 
export const SET_USER_ANNOUNCEMENTS_BADGE_DATE  = namespace + 'SET_USER_ANNOUNCEMENTS_BADGE_DATE'; 


namespace = '';
export const SET_USER_CATEGORIES                = namespace + 'SET_USER_CATEGORIES';


namespace = 'userChallenges.';
export const SET_HISTORY                        = namespace + 'SET_HISTORY';
export const ADD_USERCHALLENGES                 = namespace + 'ADD_USERCHALLENGES';


namespace = '';
export const SET_USER_PLUGINS                   = namespace + 'SET_USER_PLUGINS';
export const CLEAR_USER_PLUGINS                 = namespace + 'CLEAR_USER_PLUGINS';

namespace = 'features.';
export const SET_FEATURES                       = namespace + 'SET_FEATURES';
export const CLEAR_FEATURES                     = namespace + 'CLEAR_FEATURES';



// WEBPACK FOOTER //
// ./src/actions/types/index.js